import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
/* eslint-disable prettier/prettier */

/* eslint-disable no-console */

/* eslint-disable array-callback-return */

import decode from 'jwt-decode';
import axios from 'axios';
import moment from 'moment';
import { auth } from '../api/ApiUrl';
import { storeArq } from 'correos-arq-utils';

var createHistory = require('history').createBrowserHistory;

var uuidv4 = function uuidv4() {
  var dt = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
};

var capturarDatosCiD = function capturarDatosCiD(info) {
  try {
    // Cargar los datos del storeArq
    storeArq.load(); // seatar las necesarias de forma manual - se guardan en la variable de sesión storeArq

    storeArq.data.auth.userInfo.nombre = info.nombre;
    storeArq.data.auth.userInfo.apellidos = info.apellidoUno + " " + info.apellidoDos;
    storeArq.data.auth.userInfo.codired = ' ';
    storeArq.data.auth.userInfo.identificador = info.elementosVerificados[0].value; // guardar los datos en el storeArq

    storeArq.save();
  } catch (error) {
    console.error("error.capturarDatosCiD: ", error);
  }
};

var capturarDatosIsam = function capturarDatosIsam(info) {
  try {
    // Cargar los datos del storeArq
    storeArq.load(); // seatar las necesarias de forma manual - se guardan en la variable de sesión storeArq

    storeArq.data.auth.access_token = info.access_token;
    storeArq.data.auth.refresh_token = info.refresh_token;
    storeArq.data.auth.token = info.id_token; // guardar los datos en el storeArq

    storeArq.save();
  } catch (error) {
    console.error("error.capturarDatosIsam: ", error);
  }
};

var capturarToken = function capturarToken(instance, rolesWeb) {
  try {
    // Cargar los datos del storeArq
    storeArq.load();

    if (storeArq.data.tipo_integracion === 'EXTERN') {
      var search = storeArq.data.idTokenNoVal;
      var pares = search.slice(1).split('#');
      var params = {}; // eslint-disable-next-line

      pares.map(function (par) {
        var _par$split$0$split = par.split('&')[0].split('='),
            _par$split$0$split2 = _slicedToArray(_par$split$0$split, 2),
            id = _par$split$0$split2[0],
            tokenISAM = _par$split$0$split2[1]; // id_token : token


        var _par$split$1$split = par.split('&')[1].split('='),
            _par$split$1$split2 = _slicedToArray(_par$split$1$split, 2),
            estado = _par$split$1$split2[0],
            cod = _par$split$1$split2[1];

        params[id] = decodeURIComponent(tokenISAM);
        params[estado] = cod;
      }); // Guardar el token valido en el storeArq

      storeArq.data.auth.token = params.id_token;
      storeArq.save(); // decodificar el token - sacar la info (paso como parametro la respuesta [infoEncoded])

      decodeToken(storeArq.data.auth.token, rolesWeb);
      instance.get(auth.userDataC_ID + '/' + storeArq.data.auth.oid, {
        headers: {
          // @ts-ignore
          'idAplicacion': window._env_.REACT_APP_CLIENT_ID_C_ID
        }
      }).then(function (response) {
        capturarDatosCiD(response.data); // Redirigir al usuario a la urlOrigen guardada en el storeArq

        var history = createHistory({
          forceRefresh: true
        });
        var url = urlDestino('token');
        history.push(url);
      })["catch"](function (error) {
        console.log("error: ", error);
      });
    } else {
      var _search = storeArq.data.idTokenNoVal;

      var _pares = _search.slice(1).split('#');

      var _params = {}; // eslint-disable-next-line

      _pares.map(function (par) {
        var _par$split$0$split3 = par.split('&')[0].split('='),
            _par$split$0$split4 = _slicedToArray(_par$split$0$split3, 2),
            id = _par$split$0$split4[0],
            codeISAM = _par$split$0$split4[1]; // id_token : token


        var _par$split$1$split3 = par.split('&')[1].split('='),
            _par$split$1$split4 = _slicedToArray(_par$split$1$split3, 2),
            estado = _par$split$1$split4[0],
            cod = _par$split$1$split4[1];

        _params[id] = decodeURIComponent(codeISAM);
        _params[estado] = cod;
      }); // @ts-ignore: Guardar el token valido en el storeArq


      storeArq.data.auth.code_auth = _params.code;
      axios.post(auth.getTokenISAM + "token", "grant_type=authorization_code" + "&code=" + storeArq.data.auth.code_auth // @ts-ignore
      + '&client_secret=' + window._env_.REACT_APP_CLIENT_SECRET_ISAM // @ts-ignore
      + "&client_id=" + window._env_.REACT_APP_CLIENT_ID_ISAM // @ts-ignore
      + "&redirect_uri=" + encodeURIComponent(urlDestino('')), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        capturarDatosIsam(response.data); // decodificar el token - sacar la info (paso como parametro la respuesta [infoEncoded])

        decodeToken(storeArq.data.auth.token, rolesWeb); // Redirigir al usuario a la urlOrigen guardada en el storeArq

        var history = createHistory({
          forceRefresh: true
        });
        var url = urlDestino('token');
        history.push(url);
      })["catch"](function (error) {
        console.error("error: ", error);
      });
    }
  } catch (error) {
    // tratando de evitar el error de que entre sin permisos y vacíos - vacía todo y manda al login
    console.error('error.capturarToken: ', error); // @ts-ignore

    storeArq.data.auth = {};
    storeArq.data.idTokenNoVal = '';
    storeArq.save();
    alert('El token no es válido o ha expirado. Por favor, vuelva a iniciar sesión.'); // cerrar sesión
    // sessionStorage.removeItem('storeArq.data');
  }
};

var decodeToken = function decodeToken(infoEncoded, rolesWeb) {
  try {
    // Cargar los datos del storeArq
    storeArq.load(); // decodificamos el token jwt

    var info = decode(infoEncoded);

    if (storeArq.data.tipo_integracion === 'INTERN') {
      // Seatar las necesarias de forma manual - se guardan en la variable de sesión storeArq
      storeArq.data.auth.userInfo.nombre = info.nombre;
      storeArq.data.auth.userInfo.apellidos = info.apellidos;
      storeArq.data.auth.userInfo.codired = info.codired || 'Codired no asignado';
      storeArq.data.auth.userInfo.identificador = info.UC || 'identificador no asignado';
      storeArq.data.auth.userInfo.email = info.email;
      storeArq.data.auth.userInfo.division = info.Division;
      storeArq.data.auth.userInfo.subdivision = info.Subdivision;
      storeArq.data.auth.userInfo.rolReal = info.roles; // matchear el rol con lo devuelto en json - metodo "includes" no soportado para IE

      if (info.roles === [] || info.roles === undefined) {
        // @ts-ignore
        storeArq.data.auth.userInfo.rol = ['Rol no asignado'];
      } else {
        var accionesWebAAsignar = [];
        var rolAccionesWeb = rolesWeb.filter(function (items) {
          return info.roles.includes(items.rol);
        }); // Rellena accionesWeb con todas las rutas accesible con los roles obtenidos

        rolAccionesWeb.forEach(function (accionesWeb) {
          accionesWeb.accion.forEach(function (accionWeb) {
            return accionesWebAAsignar.push(accionWeb);
          });
        }); // Setea las rutas accesibles borrando los duplicados
        // @ts-ignore

        storeArq.data.auth.userInfo.accionesWeb = accionesWebAAsignar.filter(function (valorActual, indiceActual, array) {
          return array.findIndex(function (arrayValue) {
            return JSON.stringify(arrayValue) === JSON.stringify(valorActual);
          }) === indiceActual;
        }); // @ts-ignore

        storeArq.data.auth.userInfo.rol = _toConsumableArray(new Set(rolAccionesWeb.map(function (ac) {
          return ac.label;
        })));
      }
    } else {
      storeArq.data.auth.oid = info.oid; // acciones web sin roles

      var accionesWeb = rolesWeb; // @ts-ignore

      storeArq.data.auth.userInfo.accionesWeb = _toConsumableArray(new Set(accionesWeb.accion));
      storeArq.data.auth.userInfo.rol = accionesWeb.label;
    } // Guardar la cracion del token


    storeArq.data.auth.iat = info.iat; // Guardar la expiracion del token

    storeArq.data.auth.exp = info.exp; // Guardar la fecha actual de la recepción del token

    storeArq.data.auth.current = Math.round(moment().valueOf() / 1000); // guardar los datos en el storeArq

    storeArq.save(); // comprobamos el estado del auth - solo para el desarrollo, prohibido en "pro"
    // console.log("storeArq.data.auth.iat: ", storeArq.data.auth.iat);
    // console.log("storeArq.data.auth.current: ", storeArq.data.auth.current);
    // console.log('[LOGIN] storeArq.auth', storeArq.data.auth);
  } catch (error) {
    console.error('error.decodeToken: ', error);
  }
}; // función que loggea al usuario llamando al ISAM


var login = function login(urlDest) {
  try {
    // Cargar los datos del storeArq
    storeArq.load();
    var logoutSys = storeArq.data.auth.logoutSys || false; // en este caso, no hay token en la url y al dar al botón redirigira y luego
    // vuelve a la página para procesar la info - se ve el botón un segundo

    if (storeArq.data.tipo_integracion === 'INTERN') {
      if (logoutSys) {
        storeArq["delete"]();

        var url = auth.getTokenISAM + 'authorize?' + 'redirect_uri=' + urlDest + '&response_type=code' + '&max_age=1' + '&state=' + uuidv4() + '&scope=openid' + '&client_secret=' + // @ts-ignore
        window._env_.REACT_APP_CLIENT_SECRET_ISAM + '&client_id=' + // @ts-ignore
        window._env_.REACT_APP_CLIENT_ID_ISAM;

        window.location.href = url;
      } else {
        var _url = auth.getTokenISAM + 'authorize?' + 'redirect_uri=' + urlDest + '&response_type=code' + '&state=' + uuidv4() + '&scope=openid' + '&client_secret=' + // @ts-ignore
        window._env_.REACT_APP_CLIENT_SECRET_ISAM + '&client_id=' + // @ts-ignore
        window._env_.REACT_APP_CLIENT_ID_ISAM;

        window.location.href = _url;
      }
    } else {
      // state, URL callback codificada en Base 64 a la que se redireccionará después de pasar por la directiva
      // @ts-ignore
      var _url2 = auth.getTokenC_ID + '/' + window._env_.REACT_APP_CLIENT_ID_C_ID + '/' + btoa(urlDest);

      window.location.href = _url2;
    }
  } catch (error) {
    console.error('error.login: ', error);
  }
};

var urlDestino = function urlDestino(path) {
  try {
    // Cargar los datos del storeArq
    storeArq.load();
    var urlDestinoPath = (path !== undefined && path !== 'token' // @ts-ignore
    ? window._env_.REACT_APP_ENDPOINT_WEB : '') + storeArq.data.urlOrigen;
    return urlDestinoPath;
  } catch (error) {
    console.error('error.urlDestino: ', error);
  }
};

export { capturarToken, login, urlDestino, decodeToken, capturarDatosCiD, capturarDatosIsam };